import { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [searchQuery, setSearchQuery] = useState("");
    
    // ✅ Define `setSearchQueryNew` to update `searchQuery`
    const setSearchQueryNew = (query) => {
        setSearchQuery(query);
    };

    return (
        <SearchContext.Provider value={{ searchQuery, setSearchQuery, setSearchQueryNew }}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => useContext(SearchContext);
